// extracted by mini-css-extract-plugin
export default {"background":"errorBoundary_background__Q9zme","slideTransition":"errorBoundary_slideTransition__jvHLn"};